module.exports = __webpack_public_path__ + "static/media/caros-regular.38b81608.woff2";